import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { BadgeEuro, ChevronRight, X } from "lucide-react";

export function ExitIntentPopup() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("wk_exit_shown")) return;
    const handler = (e) => {
      if (e.clientY <= 0 && window.innerWidth > 768) {
        setOpen(true);
        sessionStorage.setItem("wk_exit_shown", "1");
        document.removeEventListener("mouseout", handler);
      }
    };
    const t = setTimeout(() => document.addEventListener("mouseout", handler), 4000);
    return () => {
      clearTimeout(t);
      document.removeEventListener("mouseout", handler);
    };
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="max-w-md p-0 overflow-hidden border-0 rounded-2xl"
        data-testid="exit-intent-popup"
      >
        <div className="bg-forest p-8 text-center relative">
          <button
            onClick={() => setOpen(false)}
            data-testid="exit-popup-close"
            className="absolute top-4 right-4 h-8 w-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors"
          >
            <X className="h-4 w-4 text-white" />
          </button>
          <div className="mx-auto h-14 w-14 rounded-full bg-pink/15 flex items-center justify-center">
            <BadgeEuro className="h-7 w-7 text-pink" />
          </div>
          <h3 className="mt-5 font-display font-extrabold text-2xl text-white leading-tight">
            Warten Sie – sichern Sie sich bis zu 70% Förderung!
          </h3>
          <p className="mt-3 text-sm text-white/70 leading-relaxed">
            Bevor Sie gehen: Fordern Sie jetzt Ihr kostenloses, unverbindliches
            Festpreis-Angebot an. Dauert nur 2 Minuten.
          </p>
          <button
            onClick={() => {
              setOpen(false);
              navigate("/funnel");
            }}
            data-testid="exit-popup-cta"
            className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-full bg-pink px-7 py-3.5 text-sm font-bold text-white hover:bg-pink-hover transition-colors"
          >
            Jetzt Angebot sichern <ChevronRight className="h-4 w-4" />
          </button>
          <button
            onClick={() => setOpen(false)}
            className="mt-3 text-xs text-white/40 hover:text-white/70 transition-colors"
          >
            Nein danke, ich zahle weiter zu viel
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
